let token = "";

export const setToken = (newToken) => {
  token = newToken;
};

export const getToken = () => {
  return token;
};

export const url = {
  baseURL: "https://internal-api-ank7tb.hav-g.in/",
}
export const baseURL = {
	API_URL_BASE: "https://internal-api-ank7tb.hav-g.in/",
	PREVIEW_URL: {
		FEMALE: "https://traya.health/pages/female-result/",
		MALE: "https://traya.health/pages/result4/",
	},
	FORM_URL: "https://form.traya.health/",
	CRM_BASE_URL: 'https://crmnewui.traya.health/'
};
export const PUBLIC_VAPID_KEY =
	"BCho54cnMquwR-3qp3lJTZUKf9jFikDTWCa7XXYYAIelmLdsCXRpTGBE2NmH5SadfdwOOzBSSD0yeg2NnoU66JA";
export const USER_PING_CALL = 60000;
export const GOOGLE_OAUTH_CLIENT_ID =
	"121360168114-i6dfm1qgt1mkrt63dhojrgolggv8ri1e.apps.googleusercontent.com";

	export const opsTeamMember = {
		"jaiswalneelu@traya.health": {
		  value: "91ce29b3-5e45-4411-b0e0-7c0ef6954599", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Neelu",
		},
		"ganeshkamble@traya.health": {
		  value: "18ef9561-3d85-4f6e-a166-74bba0df828e", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Ganesh Kamble",
		},
		"sindhu@tatva.health": {
		  value: "eb4012d2-408b-4e22-b979-4c5af9dc2aab", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Sindhu",
		},
		"patilgaurang@traya.health": {
		  value: "1105394b-d5b8-459f-b5bd-721a77cc3a1c", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Gaurang",
		},
		"deyashish@traya.health": {
		  value: "1c911188-5dcd-404e-9f28-b38213491796", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Ashish",
		},
		"yadavpratibha@traya.health": {
		  value: "873ed717-13d0-45b6-80dc-d572dffb0be2", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Pratibha",
		},
		"sneha@traya.health": {
			value: "d29d1dff-4c54-423e-8249-5ec53f4d0385", // prod
			// value: "01606e96-fc51-480c-8542-1040528a82dc", //dev
			label: "Sneha",
		},
		"snehakusuma187@gmail.com": {
			value: "6a42bb1b-f76b-4550-a1ed-6033ba9e5baf", // prod
			// value: "01606e96-fc51-480c-8542-1040528a82dc", //dev
			label: "Sneha",
		},
		"choudharyphilona@traya.health": {
			value: "3b311a50-7606-4524-b711-a4888c3143b2", // prod
			// value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
			label: "Philona Choudhary",
		},
		"mitraparth@traya.health": {
			value: "d8c044ee-e3fc-4519-a12f-94ec87a56124", // prod
			// value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
			label: "Parth",
		  }
	  };

	  export const escalationTeamMember = {
		"priyankakanojia@traya.health": {
		  value: "3d095db2-c84a-4d27-9e2c-c3b37d7793ab", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Priyanka kanojia",
		},
		"khanmahenaaz@traya.health": {
		  value: "fbbdd445-3df2-48ee-8726-4e96856ce78c", // prod
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Khan Mahenaaz",
		},
		"siddhi@tatva.health": {
		  value: "8906e2cb-11c6-4f8b-8def-54d7c40deeab",
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Siddhi",
		},
		"kalyani@tatva.health": {
		  value: "1c290664-1ea9-43bc-81f1-554d26eee917",
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Kalyani",
		},
		"harish@traya.health": {
		  value: "c5fc686a-8f31-4419-8151-fd8e5c1ee7ee",
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Harish",
		},
		"shefali@tatva.health": {
		  value: "51e339f9-4d49-4af1-9c0d-f5662e43c1d1",
		  // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		  label: "Shefali",
		},
	  };

export const assignToOptions = {
	order_related: {
		refund: [
			{
				value: '91ce29b3-5e45-4411-b0e0-7c0ef6954599',
				label: 'Neelu',
				email: 'jaiswalneelu@traya.health',
			},
		],
		order_cancellation: [
			{
				value: '18ef9561-3d85-4f6e-a166-74bba0df828e',
				label: 'Ganesh Kamble',
				email: 'ganeshkamble@traya.health',
			},
		],
		wrong_order: [
			{
				value: 'eb4012d2-408b-4e22-b979-4c5af9dc2aab',
				label: 'Sindhu',
				email: 'sindhu@tatva.health',
			},
		],
		reverse_pick_up: [
			{
				value: 'eb4012d2-408b-4e22-b979-4c5af9dc2aab',
				label: 'Sindhu',
				email: 'sindhu@tatva.health',
			},
		],
		edit_order: [
			{
				value: 'eb4012d2-408b-4e22-b979-4c5af9dc2aab',
				label: 'Sindhu',
				email: 'sindhu@tatva.health',
			},
		],
	},
	delivery_related: {
		delivery_issues: [
			{
				value: '1937c2c3-259e-431a-8606-75d4887fe8ab',
				label: 'Saily',
				email: 'saily@traya.health',
			},
		],
		damaged_product: [
			{
				value: 'eb4012d2-408b-4e22-b979-4c5af9dc2aab',
				label: 'Sindhu',
				email: 'sindhu@tatva.health',
			},
		],
	},
	prescription_related: {
		prescription_request: [
			{
				value: '1c911188-5dcd-404e-9f28-b38213491796',
				label: 'Deyashish',
				email: 'deyashish@traya.health',
			},
		],
	},
};
  export const FEEDBACK_FORM = {
	PROD_URL: "https://customerfeedback.traya.health",
	DEV_URL: "https://customerfeedback.dev.hav-g.in",
  };
  export const techTeamMember = {
	"agarwalsandip@traya.health": {
		value: "4f9f70c7-f4e1-466e-a387-01d359fd9b93", //prod
		// value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
		label: "Sandip Agarwal",
	},
};
export const CALL_HIPPO_TOKEN = "63f8b28bed9535141b703789";
export const CALL_HIPPO_EMAIL = "agarwalsandip@traya.health";
